<section-header
	sectionTitle="Civil Rights Compliance"
	navPath="/crc"
	containerClass=""
	[navLinks]="navLinks"></section-header>
